import { render } from "./HistoryGetFriendList.vue?vue&type=template&id=6c2b4d18&scoped=true"
import script from "./HistoryGetFriendList.vue?vue&type=script&lang=js"
export * from "./HistoryGetFriendList.vue?vue&type=script&lang=js"

import "./HistoryGetFriendList.vue?vue&type=style&index=0&id=6c2b4d18&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2b4d18"]])

export default __exports__